<template>
  <svg enable-background="new 0 0 100 100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path v-for="(d, index) in icons[icon]" :key="index" :d="d"/></svg>
</template>

<script>
  export default {
    name: 'SvgIcon',
    props: {
      icon: {
        type: String,
        default: 'new_window',
        validator: (value) => {
          return ['new_window', 'calc', 'close', 'minus', 'plus'].includes(value) !== -1
        },
      }
    },
    computed: {
      icons() {
        const icons = {
          new_window: [
            'm100 3.3v30c0 1.8-1.5 3.3-3.3 3.3s-3.3-1.5-3.3-3.3v-21.9l-47.7 47.6c-1.3 1.3-3.4 1.3-4.7 0s-1.3-3.4 0-4.7l47.6-47.6h-21.9c-1.8 0-3.3-1.5-3.3-3.3s1.4-3.4 3.3-3.4h30c1.8 0 3.3 1.5 3.3 3.3zm-13.4 86.7v-40c0-1.8-1.5-3.3-3.3-3.3s-3.3 1.5-3.3 3.3v40c0 1.8-1.5 3.3-3.3 3.3h-66.7c-1.8 0-3.3-1.5-3.3-3.3v-66.7c0-1.8 1.5-3.3 3.3-3.3h40c1.8 0 3.3-1.5 3.3-3.3s-1.5-3.3-3.3-3.3h-40c-5.5 0-10 4.5-10 10v66.6c0 5.5 4.5 10 10 10h66.7c5.5 0 9.9-4.5 9.9-10z'
          ],
          calc: [
            'm91.2 0h-82.4c-4.9 0-8.8 3.9-8.8 8.8v82.4c0 4.9 3.9 8.8 8.8 8.8h82.4c4.9 0 8.8-3.9 8.8-8.8v-82.4c0-4.9-3.9-8.8-8.8-8.8zm2.9 8.8v38.3h-41.2v-41.2h38.3c1.6 0 2.9 1.3 2.9 2.9zm-85.3-2.9h38.3v41.2h-41.2v-38.3c0-1.6 1.3-2.9 2.9-2.9zm-2.9 85.3v-38.3h41.2v41.2h-38.3c-1.6 0-2.9-1.3-2.9-2.9zm85.3 2.9h-38.3v-41.2h41.2v38.3c0 1.6-1.3 2.9-2.9 2.9z',
            'm17.8 29.5h5.9v5.9c-.1 1.6 1.2 3 2.8 3 1.6.1 3-1.2 3-2.8 0-.1 0-.2 0-.2v-5.9h5.9c1.6.1 3-1.2 3-2.8.1-1.6-1.2-3-2.8-3-.1 0-.2 0-.2 0h-5.9v-5.8c-.1-1.6-1.4-2.9-3-2.8-1.5.1-2.7 1.3-2.8 2.8v5.9h-5.8c-1.6.1-2.9 1.4-2.8 3-.1 1.4 1.1 2.6 2.7 2.7z',
            'm30.7 73.4 4.1-4.1c1.1-1.2 1-3-.2-4.1-1.1-1-2.9-1-4 0l-4.1 4.1-4.1-4.1c-1.2-1.1-3-1-4.1.2-1 1.1-1 2.9 0 4l4.1 4.1-4.1 4.1c-1.1 1.2-1 3 .2 4.1 1.1 1 2.9 1 4 0l4.1-4.1 4.1 4.1c1.2 1.1 3 1 4.1-.2 1-1.1 1-2.9 0-4z',
            'm82.2 64.7h-17.5c-1.6-.1-3 1.2-3 2.8-.1 1.6 1.2 3 2.8 3h.2 17.6c1.6.1 3-1.2 3-2.8.1-1.6-1.2-3-2.8-3-.1-.1-.2-.1-.3 0z',
            'm82.2 76.4h-17.5c-1.6-.1-3 1.2-3 2.8-.1 1.6 1.2 3 2.8 3h.2 17.6c1.6.1 3-1.2 3-2.8.1-1.6-1.2-3-2.8-3-.1 0-.2 0-.3 0z',
            'm64.7 29.5h17.6c1.6.1 3-1.2 3-2.8.1-1.6-1.2-3-2.8-3-.1 0-.2 0-.2 0h-17.6c-1.6-.1-3 1.2-3 2.8-.1 1.6 1.2 3 2.8 3z'
          ],
          close: [
            'm97.8 2.3c-3-3-7.7-3-10.7 0l-37.1 37-37.1-37.1c-3-3-7.7-3-10.7 0-3 3-3 7.7 0 10.7l37.1 37.1-37.1 37.1c-3 3-3 7.7 0 10.7s7.7 3 10.7 0l37.1-37.1 37.1 37.1c3 3 7.7 3 10.7 0s3-7.7 0-10.7l-37.1-37.1 37.1-37.1c2.9-2.9 2.9-7.7 0-10.6z'
          ],
          minus: [
            'm69.3 3.8c-6.1-2.5-12.7-3.8-19.2-3.8-.3 0-.6 0-.9 0-27.6.5-49.6 23.3-49.1 50.9.4 19.8 12.4 37.6 30.7 45.2 6.1 2.5 12.6 3.8 19.2 3.8h.9c27.6-.5 49.6-23.3 49.1-50.9-.4-19.8-12.4-37.5-30.7-45.2zm-4.7 49.7h-29.2v-6.8h29.2z'
          ],
          plus: [
            'm69.3 3.8c-6.1-2.5-12.7-3.8-19.2-3.8-.3 0-.6 0-.9 0-27.6.5-49.6 23.3-49.1 50.9.4 19.8 12.4 37.6 30.7 45.2 6.1 2.5 12.6 3.8 19.2 3.8h.9c27.6-.5 49.6-23.3 49.1-50.9-.4-19.8-12.4-37.5-30.7-45.2zm-2.8 49.3h-13v13.3h-6.8v-13.3h-13v-6.2h13v-13.3h6.8v13.3h13z'
          ]
        }
        return icons
      }
    }
  }
</script>